export default () => import(/* webpackChunkName: 'coffee/app/qualify-notification' */ './QualifyNotification');
